<template>
  <div class="container mx-auto p-0 lg:px-12 laptop:px-24 selector-container">
    <div class="border border-darkgray flex flex-col md:flex-row h-full">
      <!-- col 1 -->
      <div class="w-full sm:h-full selector-viewer3d-container">
        <iframe 
                allow="xr-spatial-tracking *;fullscreen *; web-share *" allowfullscreen allowtransparency="true" 
                style="width:100%; height:100%; border: 0"
                alt="Showcase of 3D models from different industries"
                :src=" models[selectedId].src" />
      </div>

      <!-- col 2 -->
      <div class="bg-darkgray text-white h-full selector-list-container">
        <div class="flex-grow w-full px-4 py-4 h-full overflow-y-auto flex flex-col gap-2">
          <div
            v-for="(model, id) of models"
            :key="id" class="relative"
            @click="selectedId = id"
          >
            <div class="flex flex-row cursor-pointer" :class="{'selected-decoration': id == selectedId}">
              <img :src="model.preview"
                   width="78" class="rounded" style="height:78px; min-width: 78px;">
              <div class="flex flex-col px-4 flex-grow justify-center">
                <div class="text-xs font-light">{{ $t(model.industry).toString() }}</div>
                <div class="text-sm">{{ $t(model.name).toString() }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
export default defineNuxtComponent({
  name: 'LandingShowcaseSelector',
  components: {},
  props: {
    compact: { type: Boolean, default: false }
  },
  data() {
    return {
      selectedId: 0,
      models: [
        {
          industry: 'showcase-selector.polyurethaneBelt.industry',
          name: 'showcase-selector.polyurethaneBelt.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/271b8584-1272-53b4-9ba7-61c2619bf01b/default/795c54ae-79c7-5c38-b4c7-35daae52375d/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/271b8584-1272-53b4-9ba7-61c2619bf01b/default/795c54ae-79c7-5c38-b4c7-35daae52375d/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.wineBottle.industry',
          name: 'showcase-selector.wineBottle.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/Zimor%204/default/default/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/Zimor%204/default/default/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.bed.industry',
          name: 'showcase-selector.bed.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/652843f1-38c7-5116-9ffb-6863d64f23a3/default/29ca8cb1-3081-5f5a-b182-ca8005869513/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/652843f1-38c7-5116-9ffb-6863d64f23a3/default/29ca8cb1-3081-5f5a-b182-ca8005869513/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.watch.industry',
          name: 'showcase-selector.watch.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/b8402fe3-866e-5cd3-8211-c1fb782b4e5c/default/ea5db9f6-7ec7-53b3-98a7-6e275d9ca6b6/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/b8402fe3-866e-5cd3-8211-c1fb782b4e5c/default/ea5db9f6-7ec7-53b3-98a7-6e275d9ca6b6/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.electronicBoard.industry',
          name: 'showcase-selector.electronicBoard.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/faa503f3-b023-5d37-8c31-eeb79cc035ee/default/703bdd6e-524e-598b-bf5a-3a70bc94e416/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/faa503f3-b023-5d37-8c31-eeb79cc035ee/default/703bdd6e-524e-598b-bf5a-3a70bc94e416/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.robotArm.industry',
          name: 'showcase-selector.robotArm.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/3fcda791-e7d4-5140-b961-73dc91dc3f96/default/1006ed32-0c1e-5d5c-8dee-da1407619797/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/3fcda791-e7d4-5140-b961-73dc91dc3f96/default/1006ed32-0c1e-5d5c-8dee-da1407619797/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.totem.industry',
          name: 'showcase-selector.totem.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/dc5b8692-f667-57d7-ba5b-a741758e1a62/default/af2fb904-4c2f-5fc1-a809-8ff289cca3f8/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/dc5b8692-f667-57d7-ba5b-a741758e1a62/default/af2fb904-4c2f-5fc1-a809-8ff289cca3f8/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.personalCare.industry',
          name: 'showcase-selector.personalCare.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/b93ea12d-ee9a-5d13-bf67-e1a631fcdef1/default/3d7f8d2a-1538-5956-be5a-e4d84fe7bb0f/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/b93ea12d-ee9a-5d13-bf67-e1a631fcdef1/default/3d7f8d2a-1538-5956-be5a-e4d84fe7bb0f/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.cushion.industry',
          name: 'showcase-selector.cushion.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/4efee09a-38a6-5ece-b843-beb9fc73d18c/default/e2ff4161-bc1a-556c-a948-66bd9aa0e6cf/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/4efee09a-38a6-5ece-b843-beb9fc73d18c/default/e2ff4161-bc1a-556c-a948-66bd9aa0e6cf/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.wc.industry',
          name: 'showcase-selector.wc.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/714fef55-d3d2-5179-aa41-4d68c71bd607/default/d4352006-fd02-5224-bcc1-8e2a7c4df856/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/714fef55-d3d2-5179-aa41-4d68c71bd607/default/d4352006-fd02-5224-bcc1-8e2a7c4df856/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.woodBurningCooker.industry',
          name: 'showcase-selector.woodBurningCooker.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/2bf0d57b-5bbb-525b-ae46-977d63c04806/default/48e27a75-d3f4-51d7-b9c0-98a18b178684/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/2bf0d57b-5bbb-525b-ae46-977d63c04806/default/48e27a75-d3f4-51d7-b9c0-98a18b178684/export/preview.jpg'
        },

        {
          industry: 'showcase-selector.hinge.industry',
          name: 'showcase-selector.hinge.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/a2f617e9-afa1-5330-a6e2-8133d85bf0fe/default/2399129f-d43a-5a21-ba18-6bec0618ea5f/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/a2f617e9-afa1-5330-a6e2-8133d85bf0fe/default/2399129f-d43a-5a21-ba18-6bec0618ea5f/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.airJordanReplica.industry',
          name: 'showcase-selector.airJordanReplica.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/7f0fde4b-8040-5d16-8d5a-2cff0360142a/default/c597abc1-2441-558c-8f7c-9b157629551c/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/7f0fde4b-8040-5d16-8d5a-2cff0360142a/default/c597abc1-2441-558c-8f7c-9b157629551c/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.cardboardStands.industry',
          name: 'showcase-selector.cardboardStands.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/6841883a-a603-54be-86b0-ec4564f5abf7/default/0c78ad1d-ef79-5a84-a460-55fb247977cd/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/6841883a-a603-54be-86b0-ec4564f5abf7/default/0c78ad1d-ef79-5a84-a460-55fb247977cd/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.coat.industry',
          name: 'showcase-selector.coat.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/1b519277-1515-5206-ac27-584872a25259/default/ba6205ae-0241-5b5a-8926-3993ba75b468/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/1b519277-1515-5206-ac27-584872a25259/default/ba6205ae-0241-5b5a-8926-3993ba75b468/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.engine.industry',
          name: 'showcase-selector.engine.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/50201c9d-6013-5fb3-abf7-cb23b55aa33d/default/06f17049-ccfb-5fab-8888-c552554c25b4/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/50201c9d-6013-5fb3-abf7-cb23b55aa33d/default/06f17049-ccfb-5fab-8888-c552554c25b4/export/preview.jpg'
        },
        {
          industry: 'showcase-selector.marbleBust.industry',
          name: 'showcase-selector.marbleBust.name',
          src: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/bf5c42c2-17e2-56ea-8285-b5d0de092985/default/cd079ba5-ecab-5e6a-b96a-5377aedb3b8c/index.html?language=' + this.$i18n.locale,
          preview: 'https://cdn.myarstudio.cloud/d9525a15-3673-4474-9841-b2b3dcb7a78a/Playground/Products/bf5c42c2-17e2-56ea-8285-b5d0de092985/default/cd079ba5-ecab-5e6a-b96a-5377aedb3b8c/export/preview.jpg'
        }
      ]
    }
  },
})
</script>

<style scoped>
.selected-decoration::before {
    content: '';
    position:absolute;
    top: 0;
    bottom: 0;
    left:-16px;
    width: 9px;
    background-color: #0B90C4;
}

.selector-container {
  overflow:hidden;
}
@media (max-width: 767px) {
  .selector-container {
  }
  .selector-viewer3d-container {
    height: 50vh;
    max-height: 550px;
  }
  .selector-list-container {
    height: 30vh;
    max-height: 550px;
  }

}
@media (min-width: 768px) {
  .selector-container {
    height: min(850px, 75vh);
    @apply flex-1
  }
}

</style>
